import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";
import { WidthFull } from "@mui/icons-material";
import { useHistory } from "react-router-dom";

export const ChartPastel = ({
  id = "pie-chart-with-title",
  datos,
  ejercicio,
  periodo,
  datosTotal,
}) => {
  const chartRef = useRef(null);
  const history = useHistory();
  // console.log(datosTotal)

  const totalClientes = datos.reduce((acc, item) => acc + item.clientes, 0);

  const formatMiles = (number) =>
    Math.floor(number / 1000).toLocaleString("es-MX");

  const datoschart = datos.map((item) => ({
    value: item.importe,
    name: item.tipo_cartera,
    porcentaje: item.porcentaje,
    clientes: item.clientes,
  }));

  useEffect(() => {
    const dom = chartRef.current;

    if (!dom) {
      return;
    }

    // Limpiar instancias previas
    if (echarts.getInstanceByDom(dom)) {
      echarts.dispose(dom);
    }

    // Inicializar el gráfico
    const myChart = echarts.init(dom);

    // Configuración de la gráfica
    const option = {
      tooltip: {
        trigger: "item",
        formatter: (params) => {
          const { name, value, data } = params;
          return `${name}:  $${formatMiles(value)} (${
            data.porcentaje
          }%)<br>Clientes: ${data.clientes}`;
        },
      },
      legend: {
        orient: "vertial",
        right: "center",
        bottom: "bottom",
      },
      grid: {
        left: "4%",
        right: "4%",
        bottom: "12%",
        top: "2%",
        containLabel: true,
      },
      graphic: [
        {
          type: "text",
          left: "center", // Posición horizontal
          top: "6%", // Posición vertical
          style: {
            text: `Total: $${formatMiles(
              datos.reduce((a, b) => a + b.importe, 0)
            )}`, // (Clientes: ${totalClientes})`, // Texto a mostrar
            fontSize: 14,
            fontWeight: "bold",
            fill: "#000", // Color del texto
          },
        },
      ],
      series: [
        {
          name: "Cartera Totales",
          type: "pie",
          radius: "40%",
          top: "10%",
          data: datoschart,
          color: ["#035917", "#fedb05", "#a71419"],
          emphasis: {
            label: {
              show: true,
              formatter: (params) => {
                const { name, value, data } = params;
                return `${name}: \n$${formatMiles(value)} (${
                  data.porcentaje
                }%)`;
              },
              fontSize: 12,
              fontWeight: "bold",
              color: "#000",
            },
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
          labelLine: {
            show: true, // Muestra las líneas
            length: 34, // Longitud de la primera parte de la línea
            length2: 16, // Longitud de la segunda parte
          },
          label: {
            formatter: (params) => {
              const { name, value, data } = params;
              return `${
                name === "Juridica" ? "Mora + 180 dias" : name
              }\n$${formatMiles(value)}\nClientes: ${data.clientes}`;
            }, // Texto de las etiquetas
            fontSize: 12,
            overflow: "break", // Evita el desbordamiento
            width: 150,
          },
        },
      ],
    };

    myChart.setOption(option);

    // Limpiar el gráfico al desmontar el componente
    return () => {
      echarts.dispose(dom);
    };
  }, [datos]);

  return (
    <div
      id={id}
      ref={chartRef}
      style={{ width: "400px", height: "100%", marginTop: "0px" }}
    />
  );
};
